import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_URL, ENDPOINTS, postData } from "../../constants/api";
import { useParams } from "react-router-dom";
import { getToken, decodeToken } from '../../utils/TokenUtils';

const token = getToken();

/* ─────────────────────────────────────────────
   CSS — A5 Invoice  (Single Page, Readable Fonts)
───────────────────────────────────────────── */
const css = `
  * { box-sizing: border-box; }
  .sp-page {
    min-height: 100vh;
    background: #f0f0f0;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 32px 16px;
    font-family: Arial, sans-serif;
  }
  .sp-card {
    width: 148mm;
    min-height: 210mm;
    background: #fff;
    position: relative;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-shadow: 0 4px 24px rgba(0,0,0,0.13);
    font-weight: bold;
    color: #111;
  }
  .sp-watermark {
    position: absolute;
    top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    width: 100%; height: 100%;
    z-index: 0; pointer-events: none;
    display: flex; align-items: center; justify-content: center;
  }
  .sp-watermark img  { width: 300px; opacity: 0.05; object-fit: contain; }
  .sp-watermark-svg  { width: 280px; height: 280px; opacity: 0.04; }
  .sp-inner {
    position: relative; z-index: 1;
    display: flex; flex-direction: column; flex: 1;
  }

  /* ── Logo + Name block ── */
  .sp-logo-name-block {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 7px 8px 0;
  }
  .sp-logo-name-block img {
    height: 75px;
    object-fit: contain;
    margin-bottom: 4px;
  }
  .sp-logo-name-block .sp-logo-placeholder {
    margin-bottom: 4px;
  }
  .sp-name-text {
    font-weight: 900;
    font-size: 15px;
    color: #232950;
    letter-spacing: 0.5px;
    text-align: center;
    padding-bottom: 5px;
  }
  .sp-name-divider {
    width: 90%;
    height: 2.5px;
    background: #F0801C;
    border: none;
    margin: 0 auto 3px;
  }

  .sp-logo-placeholder {
    display: inline-flex; align-items: center; justify-content: center;
    width: 65px; height: 65px; border-radius: 50%;
    background: #F0801C; color: #fff;
    font-size: 9px; font-weight: 900; line-height: 1.3; text-align: center;
    border: 3px solid #F0801C;
  }

  /* ── Header details ── */
  .sp-details {
    display: flex; justify-content: space-between;
    padding: 4px 10px; font-size: 10px;
    border-bottom: 1px solid #eee;
  }
  .sp-details-col p  { margin: 1.5px 0; }
  .sp-details-col .lbl { color: #F0801C; font-weight: 900; }
  .sp-details-col .val { color: #111;    font-weight: 700; }

  /* ── Items table ── */
  .sp-table {
    width: 95%; margin: 4px auto;
    border-collapse: collapse; font-size: 10px; font-weight: bold;
  }
  .sp-table th {
    background: #F0801C; color: #fff;
    padding: 4px 4px; border: 1px solid #F0801C;
    text-align: center; font-weight: 900; font-size: 10px;
  }
  .sp-table td {
    padding: 3.5px 4px; border: 1px solid #F0801C;
    text-align: center; font-size: 10px;
  }

  /* ── Totals ── */
  .sp-totals {
    width: 95%; margin: 2px auto 3px;
    border-collapse: collapse; font-size: 10.5px;
  }
  .sp-totals td { padding: 2px 6px; text-align: right; }
  .sp-totals .tot-lbl { color: #555; font-weight: 700; width: 60%; }
  .sp-totals .tot-val { color: #111; font-weight: 900; width: 40%; }
  .sp-totals .balance-row td {
    border-top: 2px solid #F0801C; color: #F0801C;
    font-size: 11px; padding-top: 3px;
  }

  .sp-spacer { height: 5px; }
  .sp-director { text-align: center; padding: 3px 0 1px; font-size: 13px; font-weight: 900; }
  .sp-sep { width: 110px; height: 2px; background: #111; margin: 0 auto 3px; border-radius: 2px; }
  .sp-payment {
    text-align: center; font-weight: 900;
    padding: 2px 0 4px; font-size: 11.5px; line-height: 1.5; color: #111;
  }

  /* ── Footer bar ── */
  .sp-footer-bar {
    margin-top: auto;
    background: #F0801C;
    color: #fff;
    padding: 5px 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
  }
  .sp-footer-info {
    font-size: 10.5px;
    line-height: 1.4;
    flex: 1;
  }
  .sp-footer-info strong {
    font-size: 10.5px;
    display: block;
    margin-bottom: 1px;
    font-weight: 900;
  }
  .sp-qr-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-shrink: 0;
  }
  .sp-qr-label {
    font-size: 8px;
    font-weight: 900;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: #fff;
    margin-bottom: 2px;
    opacity: 0.95;
  }
  .sp-qr-img {
    width: 62px;
    height: 62px;
    object-fit: contain;
    background: #fff;
    border-radius: 4px;
    border: 2px solid #fff;
    display: block;
  }

  .sp-sig-section { display: flex; gap: 10px; padding: 0 10px 5px; }
  .sp-sig-group   { flex: 1; }
  .sp-sig-lbl     { font-size: 9px; color: #888; margin-bottom: 3px; display: block; }
  .sp-sig-line    { border-bottom: 1px solid #bbb; height: 18px; display: block; }
  .sp-status {
    display: flex; align-items: center; justify-content: center;
    height: 200px; font-size: 13px; color: #888;
  }

  @media print {
    @page {
      size: A5 portrait;
      margin: 0;
    }
    html, body {
      margin: 0;
      padding: 0;
      width: 148mm;
      height: 210mm;
    }
    .sp-page {
      background: none;
      padding: 0;
      min-height: unset;
    }
    .sp-card {
      box-shadow: none;
      width: 148mm;
      height: 210mm;
      min-height: unset;
      max-height: 210mm;
      overflow: hidden;
      page-break-after: avoid;
      page-break-inside: avoid;
    }
    .sp-table th,
    .sp-footer-bar {
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }
    .sp-qr-img {
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }
  }
`;

/* ─────────────────────────────────────────────
   Helpers
───────────────────────────────────────────── */
const toObject = (v) => {
  if (!v) return {};
  if (Array.isArray(v) && v.length > 0) return v[0];
  if (typeof v === "object" && !Array.isArray(v)) return v;
  return {};
};

const toArray = (v) => {
  if (!v) return [];
  if (Array.isArray(v)) {
    const flat = v.flatMap((r) => (Array.isArray(r) ? r : [r]));
    return flat.filter((r) => r && typeof r === "object");
  }
  if (typeof v === "object") return [v];
  return [];
};

const parseResponse = (raw) => {
  console.log("🟡 RAW API response:", JSON.stringify(raw, null, 2));

  let data = raw;

  if (raw && !Array.isArray(raw) && Array.isArray(raw.data)) {
    data = raw.data;
  }

  if (!Array.isArray(data)) {
    console.warn("⚠️  Expected array, got:", typeof data);
    return { header: {}, items: [], footer: {} };
  }

  const hasTitle = data.some((d) => d && typeof d.title === "string");

  if (hasTitle) {
    const headerSec = data.find((d) => d?.title === "header");
    const footerSec = data.find((d) => d?.title === "Footer");
    const itemsSecs = data.filter((d) => d?.title === "items");

    const header = toObject(headerSec?.fields ?? headerSec?.table);
    const footer = toObject(footerSec?.fields ?? footerSec?.table);
    const items  = itemsSecs.flatMap((s) => toArray(s.table ?? s.fields));

    console.log("✅ Shape A — header:", header, "| items count:", items.length, "| footer:", footer);
    return { header, items, footer };
  }

  const headerRow = data.find((d) => d?.title === "header");
  const footerRow = data.find((d) => d?.title === "Footer");
  const itemRows  = data.filter((d) => d?.title === "items");

  const stripTitle = (obj) => {
    if (!obj) return {};
    const { title, ...rest } = obj;
    return rest;
  };

  const header = stripTitle(headerRow);
  const footer = stripTitle(footerRow);
  const items  = itemRows.map(stripTitle);

  console.log("✅ Shape B — header:", header, "| items count:", items.length, "| footer:", footer);
  return { header, items, footer };
};

const visibleKeys = (obj, exclude = ["title", "item_group"]) =>
  Object.keys(obj || {}).filter((k) => !exclude.includes(k));

const isRightAligned = (col) =>
  ["price", "amount", "qty", "quantity", "total", "cost"].some((w) =>
    col.toLowerCase().includes(w)
  );

/* ─────────────────────────────────────────────
   Component
───────────────────────────────────────────── */
const SalesPrint = () => {
  const { id, route } = useParams();

  const [company,  setCompany]  = useState({});
  const [header,   setHeader]   = useState({});
  const [items,    setItems]    = useState([]);
  const [footer,   setFooter]   = useState({});
  const [itemCols, setItemCols] = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [error,    setError]    = useState(null);

  const isSignatureShow =
    route?.includes("InPatient") || route?.includes("Discharge");

  /* ── Company ── */
  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const response = await axios.get(
          `${API_URL}/${ENDPOINTS.SYS}/getlink/company-info`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const companyData = response.data.report[0];
        setCompany(companyData);
        if (companyData?.name) document.title = companyData.name;
        if (companyData?.logo) {
          const favicon = document.querySelector("link[rel='icon']");
          if (favicon) favicon.href = `${API_URL}/${companyData.logo}`;
        }
      } catch (err) {
        console.log("Error fetching company:", err);
      }
    };
    fetchCompany();
  }, []);

  /* ── Invoice data ── */
  useEffect(() => {
    if (!id || !route) return;

    setLoading(true);
    setError(null);

    const url = `${API_URL}/${ENDPOINTS.SYS}/activityReport/${route}`;

    postData(url, { id })
      .then((result) => {
        console.log("🔵 Full postData result:", JSON.stringify(result, null, 2));

        const { header, items, footer } = parseResponse(result?.data ?? result);

        setHeader(header);
        setItems(items);
        setFooter(footer);

        if (items.length > 0) {
          setItemCols(visibleKeys(items[0]));
        }

        setLoading(false);
      })
      .catch((err) => {
        setError("Waa jirtay khalad. Fadlan dib u load garee.");
        setLoading(false);
      });
  }, [id, route]);

  /* ── Auto-print ── */
  useEffect(() => {
    if (!loading && !error) {
      const t = setTimeout(() => window.print(), 600);
      return () => clearTimeout(t);
    }
  }, [loading, error]);

  /* ── Split header keys ── */
  const headerKeys = visibleKeys(header);
  const half       = Math.ceil(headerKeys.length / 2);
  const leftKeys   = headerKeys.slice(0, half);
  const rightKeys  = headerKeys.slice(half);
  const footerKeys = Object.keys(footer);

  /* ── Render ── */
  return (
    <>
      <style>{css}</style>
      <div className="sp-page">
        <div className="sp-card">

          {/* Watermark */}
          <div className="sp-watermark">
            {company.logo ? (
              <img src={`${API_URL}/${company.logo}`} alt="" />
            ) : (
              <svg className="sp-watermark-svg" viewBox="0 0 100 100">
                <circle cx="50" cy="50" r="45" fill="none" stroke="#F0801C" strokeWidth="3" />
                <text x="50" y="40" textAnchor="middle" fontSize="10" fontWeight="900" fill="#F0801C">JS</text>
                <text x="50" y="53" textAnchor="middle" fontSize="10" fontWeight="900" fill="#F0801C">COMPANY</text>
                <text x="50" y="66" textAnchor="middle" fontSize="10" fontWeight="900" fill="#F0801C">Ltd.Co</text>
              </svg>
            )}
          </div>

          <div className="sp-inner">

            {/* ── Logo + Name + Divider ── */}
            <div className="sp-logo-name-block">
              {company.logo ? (
                <img src={`${API_URL}/${company.logo}`} alt="Logo" />
              ) : (
                <div className="sp-logo-placeholder">
                  JS<br />COMPANY<br />Ltd.Co
                </div>
              )}
              <div className="sp-name-text">
                {company.name || "JS COMPANY LTD.CO."}
              </div>
              <hr className="sp-name-divider" />
            </div>

            {loading && <div className="sp-status">Loading invoice…</div>}
            {!loading && error && (
              <div className="sp-status" style={{ color: "#F0801C" }}>{error}</div>
            )}

            {!loading && !error && (
              <>
                {/* ── Header details ── */}
                <div className="sp-details">
                  <div className="sp-details-col">
                    {leftKeys.map((k) => (
                      <p key={k}>
                        <span className="lbl">{k}: </span>
                        <span className="val">{header[k]}</span>
                      </p>
                    ))}
                  </div>
                  <div className="sp-details-col" style={{ textAlign: "right" }}>
                    {rightKeys.map((k) => (
                      <p key={k}>
                        <span className="lbl">{k}: </span>
                        <span className="val">{header[k]}</span>
                      </p>
                    ))}
                  </div>
                </div>

                {/* ── Items table ── */}
                <table className="sp-table">
                  <thead>
                    <tr>
                      <th style={{ width: 24 }}>No.</th>
                      {itemCols.map((col) => (
                        <th key={col}>{col.replace(/_/g, " ")}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {items.length === 0 ? (
                      <tr>
                        <td
                          colSpan={Math.max(itemCols.length + 1, 5)}
                          style={{ color: "#888", padding: "10px" }}
                        >
                          — Alaab lama helin —
                        </td>
                      </tr>
                    ) : (
                      items.map((row, i) => (
                        <tr key={i}>
                          <td style={{ color: "#F0801C" }}>{i + 1}</td>
                          {itemCols.map((col, ci) => (
                            <td
                              key={col}
                              style={{
                                textAlign:
                                  ci === 0
                                    ? "left"
                                    : isRightAligned(col)
                                    ? "right"
                                    : "center",
                              }}
                            >
                              {row[col] ?? "—"}
                            </td>
                          ))}
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>

                {/* ── Totals ── */}
                {footerKeys.length > 0 && (
                  <table className="sp-totals">
                    <tbody>
                      {footerKeys.map((k) => (
                        <tr
                          key={k}
                          className={k.toLowerCase() === "balance" ? "balance-row" : ""}
                        >
                          <td className="tot-lbl">{k}</td>
                          <td className="tot-val">{footer[k]}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}

                <div className="sp-spacer" />

                {/* Signature */}
                {isSignatureShow && (
                  <div className="sp-sig-section">
                    {["Approved By", "Signature", "Date"].map((lbl) => (
                      <div key={lbl} className="sp-sig-group">
                        <span className="sp-sig-lbl">{lbl}</span>
                        <span className="sp-sig-line" />
                      </div>
                    ))}
                  </div>
                )}

                {/* Finance director */}
                <div className="sp-director">Finance director</div>
                <div className="sp-sep" />

                {/* Payment info */}
                <div className="sp-payment">
                  <span>Finance Method</span><br />
                  <span>{company.name}</span><br />
                  <span>0840287271663</span><br />
                  <span>(Equity Bank)</span>
                </div>
              </>
            )}

            {/* ── Footer bar ── */}
            <div className="sp-footer-bar">
              <div className="sp-footer-info">
                <strong>{company.name || "JS COMPANY Ltd.Co"}</strong>
                {company.email}<br />
                0722453702
              </div>
              <div className="sp-qr-section">
                <span className="sp-qr-label">WhatsApp</span>
                <img
                  className="sp-qr-img"
                  src={`${API_URL}/uploads/company/value-1779092603265-724829463.png`}
                  alt="WhatsApp QR Code"
                  onError={(e) => { e.target.style.display = "none"; }}
                />
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default SalesPrint;